import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { border, shadow, color, space, layout } from 'styled-system';
import themeGet from '@styled-system/theme-get';
export var CardElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  position: relative;\n  transition: all 400ms ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  position: relative;\n  transition: all 400ms ", ";\n"])), border, color, layout, shadow, space, themeGet('easings.smooth.string'));
var templateObject_1;
